import { useQuery } from 'convex/react';
import { useState } from 'react';

import { api } from '../../convex/_generated/api';

export default function LiveScoring() {
  const currentSeason = useQuery(api.seasons.getCurrent);
  const [week, setWeek] = useState<number>(1);

  const scoring = useQuery(
    api.nfl.scoring.getLiveScoring,
    currentSeason ? { season: currentSeason.year, week } : 'skip',
  );
  const franchises = useQuery(api.franchises.listFranchises);

  if (!currentSeason || !scoring || !franchises) {
    return <div className="p-4">Loading…</div>;
  }
  const fById = new Map(franchises.map((f) => [f._id, f]));

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <header className="mb-4">
        <h1 className="text-2xl font-bold">Live Scoring</h1>
        <p className="text-sm text-gray-600 mt-1">
          Post-game scoring (~15 min after each NFL game ends). nflverse data; not per-play.
        </p>
        <div className="mt-2">
          <label className="text-sm mr-2 inline-flex items-center gap-1">
            Week:
            <select
              value={week}
              onChange={(e) => setWeek(Number(e.target.value))}
              className="border rounded px-2 py-1"
            >
              {Array.from({ length: 18 }, (_, i) => i + 1).map((w) => (
                <option key={w} value={w}>
                  Week {w}
                </option>
              ))}
            </select>
          </label>
        </div>
      </header>

      <div className="grid gap-3 md:grid-cols-2">
        {scoring.map((m) => {
          const away = fById.get(m.awayFranchiseId);
          const home = fById.get(m.homeFranchiseId);
          if (!away || !home) return null;
          return (
            <div key={m._id} className="border rounded p-3 bg-white shadow-sm flex flex-col">
              <div className="flex items-center justify-between">
                <span className="font-medium">{away.name}</span>
                <span className="font-mono text-lg">{m.awayScore.toFixed(2)}</span>
              </div>
              <div className="flex items-center justify-between mt-1">
                <span className="font-medium">{home.name}</span>
                <span className="font-mono text-lg">{m.homeScore.toFixed(2)}</span>
              </div>
              <div className="text-xs text-gray-500 mt-2">
                {m.status === 'final'
                  ? 'Final'
                  : m.status === 'in_progress'
                    ? 'Games in progress'
                    : 'Scheduled'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
